// The prototype's tooltip is a dark bubble, not a light chip. Defined once here
// because reactstrap's Tooltip takes its surface as an inline style object, so it
// cannot pick this up from the global stylesheet the way buttons and modals do.
export const TOOLTIP_SURFACE = {
    backgroundColor: "var(--pw-dark)",
    color: "var(--text-on-brand)",
    borderRadius: "var(--pw-radius-lg)",
    fontSize: "var(--pw-text-hint)",
    fontWeight: "var(--pw-weight-light)",
    lineHeight: "var(--pw-leading-normal)",
};

export const tooltipSurface = (maxWidth) => ({ ...TOOLTIP_SURFACE, maxWidth });

export default TOOLTIP_SURFACE;
